import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActivityResponse } from "models/Home";
import { getActivityAPI, getWalletBalanceAPI, removeActivityByIdAPI } from "services/api/home";

export const getActivity = createAsyncThunk<ActivityResponse, string>(
  "loader/home/activity",
  async (alertType, { rejectWithValue }) => {
    try {
      const { data } = await getActivityAPI(alertType);

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const getWalletBalance = createAsyncThunk(
  "loader/home/wallet-balance",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getWalletBalanceAPI();

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const removeActivityById = createAsyncThunk(
  "loader/home/remove-activity",
  async (id: string, { rejectWithValue }) => {
    try {
      const { status } = await removeActivityByIdAPI(id);

      return status;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);
